import type { TField } from "@shared/types/form";
import { Field, FieldError, FieldLabel } from "@shared/ui/field";
import { Input } from "@shared/ui/input";
import { useMemo } from "react";
import { useFieldContext } from ".";

export function TextField({ trailingIcon, leadingIcon, label, ...props }: TField) {
	const field = useFieldContext();
	const isInvalid = useMemo(
		() => field.state.meta.isTouched && !field.state.meta.isValid,
		[field.state.meta.isTouched, field.state.meta.isValid]
	);
	return (
		<Field data-invalid={isInvalid}>
			<FieldLabel htmlFor={field.name}>{label}</FieldLabel>
			<div className="relative">
				{leadingIcon}
				<Input
					id={field.name}
					name={field.name}
					value={field.state.value as string}
					onBlur={field.handleBlur}
					onChange={(e) => field.handleChange(e.target.value)}
					aria-invalid={isInvalid}
					autoComplete="off"
					{...props}
				/>
				{trailingIcon}
			</div>
			{isInvalid && <FieldError errors={field.state.meta.errors} />}
		</Field>
	);
}
